function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Artboard_1",
  "data-name": "Artboard 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "path",
  d: "M191-208c-307.625,101.562-420.375-49.562-446,370s101.625,208.438,112,520S150.625,820.438,227,818s217.625,30.438,352,236,577.62,488.44,736,464,359.62-299.56,508-192,438.68,58.85,484-24c48.38-88.44,115.62-617.562-198-728s-644.38-177.562-626-360-172.38-325.562-344-350S830.625-283.562,621-232,498.625-309.562,191-208Z"
}));

var SvgBackground = function SvgBackground(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 1080",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/background.ad1e44d3.svg";
export { ForwardRef as ReactComponent };